/**
 * Utilities for creating and working with arrays, including a custom {@link TArray | TArray type}.
 *
 * @note This module will likely be deprecated; the
 * {@link https://effect-ts.github.io/effect/effect/Array.ts.html | effect Array module} is
 * recommended instead.
 *
 * @module @sorrell/utilities/array
 * @experimental
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
import type { TArray } from "./Array.Types.ts";
export * from "./Array.ts";
export * from "./Array.Types.ts";
